import SubHeader from "./SubHeader";
import SubFooter from "./SubFooter";
import AboutGlanceSection from "./AboutGlanceSection";
import SectionTitle from "../../components/SectionTitle";
import Description from "../../components/about/Description";
import FAQItem from "../../components/about/FAQItem";

const contentComponentMap = {
  aboutDescription: Description,
  aboutFaqItem: FAQItem,
  aboutGlanceSection: AboutGlanceSection,
};

const AboutBenSenseiSection = ({
  id,
  title,
  titleSpan,
  subtitle,
  titleType = "none",
  content = [],
}) => {
  return (
    <>
      <SubHeader />
      <div id={id} className="about-bensensei-section">
        <div className="container bensensei-section">
          <SectionTitle
            type={titleType}
            title={title}
            spantitle={titleSpan}
            subtitle={subtitle}
          />
          {(content || []).map((block, i) => {
            const Component = contentComponentMap[block._type];
            if (!Component) {
              console.warn(`Unknown about ben-sensei content type: ${block._type}`);
              return null;
            }

            switch (block._type) {
              case 'aboutDescription':
                return (
                  <Component
                    key={block._key || i}
                    en={block.en}
                    jp={block.jp}
                  />
                );
              case 'aboutFaqItem':
                return (
                  <Component
                    key={block._key || i}
                    question={{ en: block.questionEN, jp: block.questionJP }}
                    answer={{ en: block.answerEN, jp: block.answerJP }}
                  />
                );
              case 'aboutGlanceSection':
                return (
                  <Component
                    key={block._key || i}
                    showDivider={block.showDivider}
                    title={block.title}
                    titleSpan={block.titleSpan}
                    subtitle={block.subtitle}
                    titleType={block.titleType}
                    items={block.items}
                  />
                );
              default:
                return null;
            }
          })}
        </div>
      </div>
      <SubFooter />
    </>
  );
};

export default AboutBenSenseiSection;
